import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MembershipDetailFormComponent } from './membership-detail-form.component';

@NgModule({
  declarations: [MembershipDetailFormComponent],
  exports: [MembershipDetailFormComponent, CommonModule],
  imports: [
    CommonModule,
    TranslateModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class MembershipDetailFormModule {}
